import { Wallet } from '@/core/services/Wallets/WalletInterface'

export function calculateTotalBalance(assets: Wallet[]): number {
  return assets.reduce((total, asset) => {
    const balance = parseFloat(asset.balance) | 0
    const course = parseFloat(asset.course)
    const assetValue = balance * course

    // Если у актива есть родительский кошелек, добавляем его баланс тоже
    if (asset.parents) {
      asset.parents.forEach(parent => {
        const parentBalance = parseFloat(parent.wallet.balance) | 0
        const parentCourse = parseFloat(parent.wallet.course)
        total += parentBalance * parentCourse
      })
    }

    return total + assetValue
  }, 0)
}
